import React from 'react';
import { Hero } from './components/Hero';
import { TestimonialStrip } from './components/TestimonialStrip';
import { Problema } from './components/Problema';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Oferta } from './components/Oferta';
import { SistemaTotal } from './components/SistemaTotal';
import { Testimonios } from './components/Testimonios';
import { CostoDeNoTenerlo } from './components/CostoDeNoTenerlo';
import { Garantia } from './components/Garantia';
import { Faq } from './components/Faq';
import { CierreFinal } from './components/CierreFinal';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel('1386464580182190');
  return <div className="w-full overflow-x-hidden bg-white font-sans text-ink-900" data-id="element-0" data-mp="28suw6sn6u7od">
      <Hero data-id="element-1" data-mp="23u9v6r043jyv" />
      <main data-id="element-2" data-mp="23utcc5hxu4bu">
        <TestimonialStrip data-id="element-3" data-mp="23v2sl1d6kx4c" />
        <Problema data-id="element-4" data-mp="3ijxnsm94vshs" />
        <Tomos data-id="element-5" data-mp="3ikhaeg9qb525" />
        <Bonos data-id="element-6" data-mp="3iiweonbohg2p" />
        <Oferta data-id="element-7" data-mp="3ijfx0558q6h9" />
        <SistemaTotal data-id="element-8" data-mp="3ihv1odb3qjic" />
        <Testimonios data-id="element-9" data-mp="3mlj82snzz920" />
        <CostoDeNoTenerlo data-id="element-10" data-mp="3ml17jjuay8oa" />
        <Garantia data-id="element-11" data-mp="3mk83iqmq9x9u" />
        <Faq data-id="element-12" data-mp="3mjpyp5m02aqb" />
        <CierreFinal data-id="element-13" data-mp="3mj6k9yvk64h1" />
      </main>
      <Footer data-id="element-14" data-mp="3rbzmog3k10py" />
      <PurchasePopup data-id="element-15" data-mp="3rdatkosaqola" />
    </div>;
}